var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{blurred: _vm.modelWindowOpen},attrs:{"id":"app"}},[_c('NavigationMenu',{staticClass:"blurable",attrs:{"fileName":"saab-logo-white.svg"}}),_c('transition-page',[_c('router-view',{staticClass:"page"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }